import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
/* empty css                                */
import { ProductDetailDrawer } from "../../../../../ProductDetailDrawer/modules/ProductDetailDrawer/ProductDetailDrawer.js";
import { ProductDetailSpecificationDrawerCTA } from "../../../components/ProductDetailSpecificationDrawerCTA/modules/PrimaryProductInfo/ProductDetailSpecification/components/ProductDetailSpecificationDrawerCTA/ProductDetailSpecificationDrawerCTA.js";
import { SpecificationListItem } from "../../../components/SpecificationListItem/modules/PrimaryProductInfo/ProductDetailSpecification/components/SpecificationListItem/SpecificationListItem.js";
const ProductDetailSpecification = ({ className, items }) => {
  const { getLabel } = useIntl();
  const title = getLabel("products.detail.specifications.title");
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("product-detail-specification", className),
      "aria-label": title,
      "data-t": "product-detail-specification"
    },
    /* @__PURE__ */ React.createElement(
      ProductDetailDrawer,
      {
        "data-t": "specification-drawer",
        title,
        shouldMountContent: true,
        ctaButton: /* @__PURE__ */ React.createElement(ProductDetailSpecificationDrawerCTA, { title })
      },
      /* @__PURE__ */ React.createElement(
        "dl",
        {
          className: "product-detail-specification-list",
          "data-t": "product-detail-specification-list"
        },
        items.map(({ key, label, value }) => /* @__PURE__ */ React.createElement(SpecificationListItem, { key, label, value }))
      )
    )
  );
};
export {
  ProductDetailSpecification
};
//# sourceMappingURL=ProductDetailSpecification.js.map
